<template>
  <div>
    <loading :active.sync="isLoading" background-color="#D0D0D0">
      <div class="loadingio-spinner-eclipse-y24d302hfm">
        <div class="ldio-f9ujl5oazv5">
          <div></div>
        </div>
      </div>
    </loading>

    <div v-if="show">
      <div class="wrapper">
        <Nav v-if="!NoShowCompo"></Nav>
        <Menu v-if="NoMenuPage && !NoShowCompo"></Menu>
        <router-view></router-view>
        <Footer v-if="!NoShowCompo" class="sticky_bottom"></Footer>
      </div>
    </div>
  </div>
</template>

<script>
  import Nav from '@/components/navContainer_en.vue'
  import Footer from '@/components/footer.vue'
  import Menu from '@/components/menuWrapper_en.vue'

  export default {
    components: {
      Nav,
      Footer,
      Menu,
    },
    data() {
      return {
        isLoading: true,
        show: false,
        access_token: '',
        NoMenuPage: false,
        NoShowCompo: false,
        PageName: '',
      }
    },

    metaInfo: {
      htmlAttrs: {
        lang: 'en',
      },

      meta: [
        {
          name: 'description',
          content:
            '展昭國際企業群成立於1985年10月,是台灣第一家大型民間專業展覽公司,主要從事籌辦大型國際展覽會及會議,出版展覽專刊雜誌,光碟,代理世界各國知名展會徵展業務及建構網路數位線上展覽。',
        },
        {
          name: 'keywords',
          content: '展昭展覽網,展昭,展覽,展覽行銷,展覽會,參展,世貿,南港展覽館',
        },
        {
          name: 'apple-mobile-web-app-title',
          content: '展昭展覽網',
        },

        {
          name: 'application-name',
          content: '展昭展覽網',
        },
      ],
    },

    created() {
      //驗證是否為登入狀態

      const vm = this

      let nowPage = location.href
      let activePage = nowPage.split('/')[5]
      // console.log(nowPage)

      // console.log(activePage)

      if (!activePage) {
        vm.NoMenuPage = false
      } else {
        vm.NoMenuPage = true

        vm.PageName = activePage.split('?')[0]

        if (
          vm.PageName == 'upgradeGetCard' ||
          vm.PageName == 'upgradeGetList' ||
          vm.PageName == 'inviteVIPApply' ||
          vm.PageName == 'inviteVIPList' ||
          vm.PageName == 'invitePaperApply' ||
          vm.PageName == 'inviteProxyApply' ||
          vm.PageName == 'inviteProxyList' ||
          vm.PageName == 'inviteProxyRegApply' ||
          vm.PageName == 'inviteProxyRegList' ||
          vm.PageName == 'onlineExpoVideoList' ||
          vm.PageName == 'onlineExpoCardInfo' ||
          vm.PageName == 'onlineExpoBooth' ||
          vm.PageName == 'onlineExpoBanner4' ||
          vm.PageName == 'onlineExpoBanner3' ||
          vm.PageName == 'onlineExpoBanner2' ||
          vm.PageName == 'onlineExpoBanner1' ||
          vm.PageName == 'onlineVideoAdd' ||
          vm.PageName == 'upgradeGetCardInfo' ||
          vm.PageName == 'Landing'
        ) {
          vm.NoShowCompo = true
        } else {
          vm.NoShowCompo = false
        }
      }

      const url = 'https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated'
      const info = null

      vm.$http.post(url, info).then(function (response) {
        // console.log(response)
        if (response.data == 200) {
          sessionStorage.setItem('access', '200')

          vm.isLoading = false
          vm.show = true
        } else {
          if (vm.PageName == 'Landing') {
            sessionStorage.setItem('access', '200')
            vm.isLoading = false
            vm.show = true
          } else {
            sessionStorage.setItem('access', '')
            sessionStorage.removeItem('access')
            location.replace('https://www.chanchao.com.tw/ExhibitorServiceTW/en/Landing')
          }
        }
      })
    },
  }
</script>

<style lang="scss">
  @keyframes ldio-f9ujl5oazv5 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .ldio-f9ujl5oazv5 div {
    position: absolute;
    animation: ldio-f9ujl5oazv5 1s linear infinite;
    width: 160px;
    height: 160px;
    top: 20px;
    left: 20px;
    border-radius: 50%;
    box-shadow: 0 4px 0 0 #777b7c;
    transform-origin: 80px 82px;
  }
  .loadingio-spinner-eclipse-y24d302hfm {
    width: 200px;
    height: 200px;
    display: inline-block;
    overflow: hidden;
  }
  .ldio-f9ujl5oazv5 {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }
  .ldio-f9ujl5oazv5 div {
    box-sizing: content-box;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .sticky_bottom {
    margin-top: auto;
  }
</style>
